import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { SIGNUP_LOGIN_POPUP_DISCLAIMER, SIGNUP_LOGIN_POPUP_MESSAGE } from "../shared/loginSignupCopy";
import { FtpDisclaimer } from "../shared/FtpDisclaimer";
import { buildAuthHref, locationAuthBackPath } from "../../utils/authBackPath";

/** @param {{ isTradeSlip?: boolean, compact?: boolean, message?: string, deeplink?: string | null }} props — isTradeSlip: render inside the trade slip modal; compact: match-page gate (no extra top margin) */
const LoginSignupBanner = ({ isTradeSlip = false, compact = false, message = SIGNUP_LOGIN_POPUP_MESSAGE, deeplink = null }) => {
  const location = useLocation();
  const back = useMemo(
    () => deeplink || locationAuthBackPath(location.pathname, location.search),
    [deeplink, location.pathname, location.search],
  );
  const loginHref = buildAuthHref("login", { back });
  const signupHref = buildAuthHref("signup", { back });

  return (
    <div
      className={`bg-white border border-solid border-main ${compact ? "p-3 md:p-4" : "p-[15px]"} ${!isTradeSlip && !compact ? "mt-[30px]" : ""} ${
        isTradeSlip ? "border-t-0" : ""
      }`}
    >
      <div className={`text-center ${compact ? "mb-3" : "mb-[20px]"}`}>
        <p className={`font-anton uppercase text-main ${compact ? "text-[12px] md:text-[13px] leading-snug" : "text-[14px] md:text-[16px]"}`}>
          {message}
        </p>
      </div>
      <div className="flex gap-2">
        <a
          href={loginHref}
          className={`flex-1 bg-lime hover:bg-limehover font-anton text-center uppercase cursor-pointer transition-colors text-main ${compact ? "text-[12px] md:text-[13px] px-3 py-2 md:py-2.5" : "text-[14px] md:text-[16px] px-[20px] py-[10px] md:py-[12px]"}`}
        >
          LOGIN
        </a>
        <a
          href={signupHref}
          className={`flex-1 bg-lime hover:bg-limehover font-anton text-center uppercase cursor-pointer transition-colors text-main ${compact ? "text-[12px] md:text-[13px] px-3 py-2 md:py-2.5" : "text-[14px] md:text-[16px] px-[20px] py-[10px] md:py-[12px]"}`}
        >
          SIGN UP
        </a>
      </div>
      <FtpDisclaimer
        text={SIGNUP_LOGIN_POPUP_DISCLAIMER}
        className="mt-3 text-center text-main/60"
      />
    </div>
  );
};

export default LoginSignupBanner;
